/**
 * ScrollLock Utility
 * Prevents body scroll while maintaining scrollbar gutter to avoid layout shift
 * Uses scrollbar-gutter: stable on body to keep gutter even when overflow: hidden
 */

let scrollLockCount = 0;

/**
 * Lock body scroll while maintaining scrollbar gutter
 * The gutter is preserved via CSS: body { scrollbar-gutter: stable }
 */
export function lockBodyScroll(): void {
  scrollLockCount++;

  // Only lock once, even if called multiple times
  if (scrollLockCount === 1) {
    // Add data attribute for CSS targeting (body[data-scroll-locked] { overflow: hidden })
    document.body.setAttribute('data-scroll-locked', 'true');
  }
}

/**
 * Unlock body scroll
 */
export function unlockBodyScroll(): void {
  scrollLockCount = Math.max(0, scrollLockCount - 1);

  // Only unlock when all locks are released
  if (scrollLockCount === 0) {
    // Remove data attribute
    document.body.removeAttribute('data-scroll-locked');
  }
}

/**
 * React hook for body scroll locking
 * @param enabled Whether scroll should be locked
 */
export function useScrollLock(enabled: boolean): void {
  if (typeof window === 'undefined') return;

  if (enabled) {
    lockBodyScroll();
  }
}
